export enum DocumentStatusTypes {
  Submitted = 'submitted',
  Approved = 'approved',
  Rejected = 'rejected',
}
